import { api } from '@/lib/api/axios';
import type { AppNotification, NotificationListResponse, NotificationSummary } from '@/types';

export interface WebPushSubscriptionPayload {
  endpoint: string;
  expirationTime: number | null;
  keys: { p256dh: string; auth: string };
}

export interface WebPushDeliveryResult {
  configured: boolean;
  subscriptions: number;
  sent: number;
  removed: number;
  failed: number;
}

export const NotificationService = {
  list: async (params: { page?: number; limit?: number; unreadOnly?: boolean } = {}) => {
    const { data } = await api.get<NotificationListResponse>('/notifications', { params });
    return data;
  },

  getSummary: async () => {
    const { data } = await api.get<NotificationSummary>('/notifications/summary');
    return data;
  },

  getWebPushPublicKey: async () => {
    const { data } = await api.get<{ publicKey: string | null }>('/notifications/push/public-key');
    return data;
  },

  registerWebPushSubscription: async (subscription: WebPushSubscriptionPayload) => {
    const { data } = await api.post<{ subscribed: true }>('/notifications/push/subscriptions', subscription);
    return data;
  },

  unregisterWebPushSubscription: async (endpoint: string) => {
    const { data } = await api.delete<{ subscribed: false }>('/notifications/push/subscriptions', {
      data: { endpoint },
    });
    return data;
  },

  sendTestPush: async () => {
    const { data } = await api.post<WebPushDeliveryResult>('/notifications/push/test');
    return data;
  },

  markRead: async (id: string) => {
    const { data } = await api.patch<AppNotification>(`/notifications/${id}/read`);
    return data;
  },

  markAllRead: async () => {
    const { data } = await api.patch<NotificationSummary>('/notifications/read-all');
    return data;
  },
};
